import React from 'react'

export const IconThematic = () => {
  return (
    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.67383 4.45338V3.44671C1.67383 2.76671 2.22716 2.21338 2.90716 2.21338H11.5205C12.2005 2.21338 12.7538 2.76671 12.7538 3.44671V4.45338"
        stroke="#FF7012"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.21484 12.5667V2.71338"
        stroke="#FF7012"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.94727 12.5669H8.66727"
        stroke="#FF7012"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.46777 7.39355H14.1411C14.6278 7.39355 15.0211 7.78689 15.0211 8.27355V8.80689"
        stroke="#FF7012"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.0674 14.7866V7.74658"
        stroke="#FF7012"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.64062 14.7866H12.494"
        stroke="#FF7012"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
